import { render, staticRenderFns } from "./TaxConfigurationGroupItemSidebar.vue?vue&type=template&id=d6fa73a0&scoped=true&"
import script from "./TaxConfigurationGroupItemSidebar.vue?vue&type=script&lang=js&"
export * from "./TaxConfigurationGroupItemSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fa73a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6fa73a0')) {
      api.createRecord('d6fa73a0', component.options)
    } else {
      api.reload('d6fa73a0', component.options)
    }
    module.hot.accept("./TaxConfigurationGroupItemSidebar.vue?vue&type=template&id=d6fa73a0&scoped=true&", function () {
      api.rerender('d6fa73a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/components/TaxConfigurationGroupItemSidebar.vue"
export default component.exports